import {
    SPINNER_CLOSE,
    SPINNER_DEFAULT_MESSAGE_TYPE,
    SPINNER_OPEN
} from './FullPageSpinnerConstants';

export const spinnerClose = () => ({
    type: SPINNER_CLOSE
});

export const spinnerOpen = (messageType = SPINNER_DEFAULT_MESSAGE_TYPE) => ({
    type: SPINNER_OPEN,
    payload: messageType
});
